import React, {useEffect} from 'react';
import RequestTracking from "../components/request-tracking/request-tracking";
import {connect} from "react-redux";
import Header from "../components/custom/header";

const RequestTrackingPage = (props) => {

    return (

        <div>
            <Header />
            <RequestTracking />
        </div>
    )
}


export default (RequestTrackingPage);
